/**
 * @name RequestCancelledError
 * @description a request the app deliberately superseded -- not a failure
 *
 * `cancelable()` in api.utils aborts the previous in-flight request whenever a newer one
 * starts, which is what a typeahead firing on every keystroke relies on. Axios surfaces
 * that abort as an error, but nothing went wrong: the answer simply stopped being wanted
 * before it arrived.
 *
 * It carries its own type so callers can tell it apart from a real failure. Matching on
 * the message instead would tie every consumer to this exact wording, and the wording is
 * the part most likely to change.
 */
export class RequestCancelledError extends Error {
  readonly name = 'RequestCancelledError';

  constructor(message = 'Request Cancelled') {
    super(message);
    // The console app compiles to es5, where subclassing Error otherwise leaves
    // `instanceof` false. Same reason ApiError does this.
    Object.setPrototypeOf(this, RequestCancelledError.prototype);
  }
}
